import { del } from 'utils/http/del';
import { getJson } from 'utils/http/getJson';
import { postJson } from 'utils/http/postJson';

import { CmsApiReactionContext } from './types/CmsApiReactionContext';

export async function cmsApiFetchReaction(pageId: string) {
  const reactionContext = await getJson<CmsApiReactionContext>(
    `/data/website/reactions/cms-pages/${pageId}`,
  );

  return reactionContext;
}

export async function cmsApiCreateReaction(
  pageId: string,
  reactionType: 'LIKE' | 'LOVE' | 'INSPIRED',
) {
  const reactionContext = await postJson<CmsApiReactionContext>(
    `/data/website/reactions/cms-pages/${pageId}`,
    { reactionType },
  );

  return reactionContext;
}

export async function cmsApiDeleteReaction(pageId: string) {
  const reactionContext = await del<CmsApiReactionContext>(
    `/data/website/reactions/cms-pages/${pageId}`,
  );

  return reactionContext;
}
